export default {
  title: 'Organization Members',
  subtitle: 'View all members of this organization',
  invite: 'Invite members',
  pending: {
    title: 'Invitations',
    subtitle: 'People invited to join this organization who have not accepted yet',
    sent: 'Sent',
    alreadyGone: 'This invitation had already been accepted, withdrawn or had expired.',
    cancelTitle: 'Cancel this invitation',
    cancelDescription: 'The link sent to {email} stops working at once.',
    cancelConfirm: 'Cancel the invitation',
    keep: 'Keep it',
  },
  table: {
    title: 'Members ({count})',
    search: 'Search members...',
    name: 'Name',
    role: 'Role',
    access: 'Access',
    status: 'Status',
    joinedAt: 'Joined',
    workspaces: 'Spaces',
    noWorkspace: 'No space',
    moreWorkspaces: '+{count}',
    moreWorkspacesLink: '+ {count} more workspaces',
    pool: 'Shared pool',
    implicitSeat: 'Implicit access: owner or administrator',
    autoAddedSeat: 'Added automatically',
    workspacesFailed: "The members' spaces could not be loaded.",
  },
  status: {
    active: 'Active',
    pending: 'Pending',
    inactive: 'Inactive',
  },
  access: {
    allSpaces: 'All spaces',
    space: '{count} space',
    spaces: '{count} spaces',
    publicOnly: 'Public spaces',
  },
  empty: {
    title: 'No members found',
    description: 'This organization has no members yet.',
    noMatch: 'No member matches this search.',
  },
  delete: {
    title: 'Remove member',
    warning: 'This member will lose access to the organization. This action cannot be undone.',
    confirm: 'Remove member',
    success: 'Member removed successfully',
  },
  editRole: {
    title: 'Edit member role',
    selectLabel: 'Role',
    success: 'Role updated successfully',
    adminDescription: 'Full access to all features and settings',
    memberDescription: 'Can view and edit content',
    viewerDescription: 'Can only view content',
    cannotEditSelf: 'You cannot change your own role',
  },
  actions: 'Actions',
  menu: {
    addToWorkspace: 'Add to workspace',
    viewDetail: 'View details',
  },
  cannotRemoveSelf: 'You cannot remove yourself',
  errors: {
    updateFailed: 'Failed to update member role',
    removeFailed: 'Failed to remove member',
    forbidden: 'You cannot act on this member, or grant this role.',
    lastAdministrator: 'This would leave the organization with nobody able to administer it.',
    gone: 'This member is no longer in the organization.',
    seatGone: 'This person is no longer a member of this space.',
  },
  tabs: {
    members: 'Members',
    invitations: 'Invitations',
  },
  invitations: {
    emailTitle: 'Email Invitations ({count})',
    linksTitle: 'Invitation Links ({count})',
    emailSectionTitle: 'Email invitations',
    emailSectionDesc: "People you invited personally who haven't joined yet.",
    linksSectionTitle: 'Invitation links',
    linksSectionDesc: 'Shareable links — one URL to join, no emails needed.',
    linksCount: '{count} link',
    linksCountPlural: '{count} links',
    pendingCount: '{count} pending',
    expiredCount: '{count} expired',
    expiredCountPlural: '{count} expired',
    expiredBanner: 'Some invitations have expired — use "Renew & resend" to generate a new valid link.',
    sentTimes: 'Sent {count}×',
    table: {
      email: 'Email',
      name: 'Name',
      unnamed: '(no name)',
      role: 'Role',
      workspaces: 'Workspaces',
      invitedBy: 'Invited by',
      expires: 'Expires',
      sendCount: 'Sent',
      code: 'Link',
      status: 'Status',
      uses: 'Uses',
      createdBy: 'Created by',
    },
    actions: {
      resend: 'Resend',
      renewResend: 'Renew & resend',
      editAccess: 'Edit access',
      cancel: 'Cancel invitation',
      copyLink: 'Copy link',
      activate: 'Activate link',
      deactivate: 'Deactivate link',
      deleteLink: 'Delete link',
    },
    editAccess: {
      title: 'Edit invitation access',
      pending: 'Pending invitation',
      success: 'Invitation access updated',
      failed: 'Failed to update invitation access',
    },
    detail: {
      title: 'Invitation link details',
      url: 'Share URL',
      orgRole: 'Organization role',
      workspaceRoles: 'Workspace assignments',
      noWorkspaces: 'No workspaces assigned',
      uses: 'Uses',
      expires: 'Expires',
      createdBy: 'Created by {name}',
    },
    expiry: {
      expired: 'Expired',
      today: 'Expires today',
      tomorrow: 'Expires tomorrow',
      expiresIn: 'Expires in {days} days',
      noExpiry: 'No expiry',
    },
    status: {
      exhausted: 'Usage limit reached',
    },
    empty: {
      noPending: 'No pending invitations',
      noPendingDescription: 'All invitations have been accepted or cancelled.',
      noLinks: 'No invitation links',
      noLinksDescription: 'Create an invitation link from the invite modal.',
    },
    resendSuccess: 'Invitation resent to {email}',
    resendTooSoon: 'Too many invitations sent for now — try again later.',
    resendGone: 'This invitation is no longer pending: it was accepted, cancelled, or it has expired.',
    resendRefused:
      'This invitation can no longer be resent as it stands — its role may have been deleted. Cancel it and invite this person again.',
    resendAlreadyMember: '{email} has already joined the organization.',
    renewSuccess: 'Invitation renewed — a new link has been sent',
    resendFailed: 'Failed to resend invitation',
    cancelSuccess: 'Invitation cancelled',
    cancelFailed: 'Failed to cancel invitation',
    linkCopied: 'Link copied to clipboard',
    linkActivated: 'Link activated',
    linkDeactivated: 'Link deactivated',
    linkDeleted: 'Link deleted',
    linkDeleteFailed: 'Failed to delete link',
    unlimited: 'Unlimited',
  },
  filters: {
    role: 'Role',
    status: 'Status',
    allRoles: 'All roles',
    allStatuses: 'All statuses',
    clear: 'Clear filters',
  },
  stats: {
    total: 'Total members',
    active: 'Active',
    pending: 'Pending',
    totalNote: 'Members of the organization',
    activeNote: 'Accepted and signed in',
    pendingNote: 'Invitations not yet accepted',
  },
  detail: {
    viewDetail: 'View member details',
    back: 'Back to members',
    memberSince: 'Member since',
    invitedBy: 'Invited by',
    owner: 'Owner',
    you: 'You',
    notFound: 'This member is no longer in the organization.',
    roleTitle: 'Role in the organization',
    roleHint: 'The change applies at once, from their next action.',
    access: {
      title: 'Space access',
      desc: 'What {name} can reach in this organization.',
      implicitAll: 'Has access to every space in the organization.',
      implicitPublic: 'Sees every public space as Viewer, in addition to the spaces below.',
      assignedCount: 'Assigned spaces · {count}',
      fullAccessNote: 'This member has full access to all spaces through their role. Individual space assignments don\'t apply.',
    },
    workspaces: {
      title: 'Spaces ({count})',
      name: 'Space',
      role: 'Role',
      joinedOn: 'Since {date}',
      fullAccess: 'Full access',
      public: 'Public',
      private: 'Private',
      noWorkspaces: 'This member is not in any space.',
      removeConfirm: 'Remove from space?',
      removeWarning: 'This member will lose access to this space.',
      removeSuccess: 'Member removed from space',
      addToWorkspace: 'Add to space',
      allJoined: 'This member already belongs to every space.',
      searchPlaceholder: 'Search spaces',
      noMatch: 'No space matches this search.',
      addConfirm: 'Add',
      addConfirmCount: 'Add | Add to {count} space | Add to {count} spaces',
      addRefused: 'Not added to {names}.',
      listLabel: 'Spaces',
      addSuccess: 'Member added to space',
      addSuccessCount: 'Member added to {count} space | Member added to {count} spaces',
      addFailed: 'Failed to add member to space',
    },
  },
}
